export const CONFIG_GET_RESPONSE = "CONFIG_GET_RESPONSE";
export const CONFIG_ERROR = "CONFIG_GET_ERROR";
export const CONFIG_REQUEST = "CONFIG_REQUEST";
export const CONFIG_UPDATE_DATA = "CONFIG_UPDATE_DATA";

export const WEBBOT_CONNECTING = "WEBBOT_CONNECTING";
export const WEBBOT_CONNECTED = "WEBBOT_CONNECTED";
export const WEBBOT_MESSAGE_RECEIVED_FROM_SDK =
  "WEBBOT_MESSAGE_RECEIVED_FROM_SDK";
export const WEBBOT_MESSAGE_SENT_TO_SDK = "WEBBOT_MESSAGE_SENT_TO_SDK";
export const WEBBOT_CLEAR_MESSAGES = "WEBBOT_CLEAR_MESSAGES";
export const WEBBOT_CONNECTION_ERROR = "WEBBOT_CONNECTION_ERROR";
export const WEBBOT_SET_IS_TYPING = "WEBBOT_SET_IS_TYPING";
export const WEBBOT_SHOW_EVERYTHING_BEFORE_WAIT =
  "WEBBOT_SHOW_EVERYTHING_BEFORE_WAIT";
export const WEBBOT_CLEAR_WAITS = "WEBBOT_CLEAR_WAITS";
export const WEBBOT_PREVIOUS_MESSAGES = "WEBBOT_PREVIOUS_MESSAGES";

export const WEBVIEW_DISABLED_INPUT = "WEBVIEW_DISABLED_INPUT";
export const WEBVIEW_SET_FOCUS_INPUT = "WEBVIEW_SET_FOCUS_INPUT";
export const WEBVIEW_SKYP_USER_INPUT = "WEBVIEW_SKYP_USER_INPUT";

export const PERSISTENT_MENU_ITEM_CLICK = "PERSISTENT_MENU_ITEM_CLICK";

export const WEBBOT_HIDE_WAITS = "WEBBOT_HIDE_WAITS";

export const ADD_PREVIEW = "ADD_PREVIEW";

export const NOOP = "NOOP";

//COMMUNICATION CONFIG
export const SAVE_WEBCHAT_DATA = "SAVE_WEBCHAT_DATA";

//CONVERSATION
export const WEBBOT_RESET_CHAT = "WEBBOT_RESET_CHAT";
export const WEBBOT_RESTARTING_CHAT = "WEBBOT_RESTARTING_CHAT";

//CVARS
export const WEBBOT_SAVE_CVARS = "WEBBOT_SAVE_CVARS";

// WEBSOCKET CODES
export const TIMEOUT_CODE = "1006";
